// Offer detail and units caches are owned by apps/web; mutations moved into this package invalidate them by these keys.
export const offerDetailQueryKey = (offerId: string) => ['offer', offerId] as const;

export const offerUnitsQueryKeyPrefix = (offerId: number) => ['offer-units', offerId] as const;

export const offerListsQueryKeyPrefix = ['offers'] as const;

export const offerAvailabilityQueryKey = (offerId: number) =>
  ['offer-availability', offerId] as const;
